// extracted by mini-css-extract-plugin
export default {"checklist":"style_checklist__R2WDB","title":"style_title__lnEWc"};